
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class ProductCombobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  // @Prop({ type: String }) schema!: string;
  // @Prop({ type: Array }) data!: any[];
  // @Prop({ type: String }) keyField!: string;
  // @Prop({ type: String }) labelField!: string;
  // @Prop({ type: String }) relField!: string;
  // @Prop({ type: String }) relFilter!: string;

  @Prop({ type: String }) clientId!: string;

  @Prop({ type: String }) position!: string;
  @Prop({ type: Boolean }) multiple!: boolean;

  @Prop({ type: String }) placeholder!: string;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    // 
  }

  public mounted() {
    this.selectdItemLabel = this.placeholder;

    // if (this.schema) {
      this.loadData();
    // } else {
    //   this.items = this.data;
    //   this.onValueChange(this.value);
    //   this.updateDisplayList();
    // }
  }
// schema="products" key-field="id" label-field="name"
  public loadData() {
    const QNAME = `SELECT_COMBOBOX_LIST_PRODUCT`;

    this.$db([
      
      this.$q(QNAME)
        .raw('documents.list')
        .action({
          columns: {
            id: 'product.id',
            label: 'product.name',
            code: 'product.code',
            position: 'product.position'
          },
          joins: [
            {
              join: 's:product_containers',
              type: 'left',
              as:   'product_container',
              on: { $eq: ['product.id', 'product_container.product_id'] }
            },
            {
              join: 's:client_product_containers',
              as:   'client_product_container',
              type: 'left',
              on: {
                $eq: ['product_container.id', 'client_product_container.product_container_id']
              }
            }
          ],
          from: 's:products',
          from_as: 'product',
          where: {
            $or: [
              {
                $and: [
                  { $eq: ['client_product_container.client_id', {$: this.clientId}] },
                  // 
                  { $null: [ 'product.archived_at' ] },
                  { $null: [ 'product_container.archived_at' ] },
                  { $eq: ['client_product_container.hidden', {$: false}] },
                ]
              },
              {
                $and: [
                  { $eq: ['product_container.is_sample', {$: true}] },
                  // 
                  { $null: [ 'product.archived_at' ] },
                  { $null: [ 'product_container.archived_at' ] },
                ]
              },
              ...(this.value ? [
                { $eq: ['product.id', {$: this.value}] },
              ] : [])
            ]
          },
          groups: [
            'product.id', 'product.promo_name', 'product.code', 'product.position'
          ],
          order: [
            {$asc: ['product.name']}
          ],
          page_size: 1000
        }),

      // .where((_: any) => {
      //   if(this.relField) {
      //     return _.eq(`product_containers.${this.relField}`, _.const(this.relFilter));
      //   } else {
      //     return undefined;
      //   }
      // })
      // .limit(1000),
    ]).then(((result: ServerResult) => {
      this.items = result.getOperation(QNAME).getContent().documents;

      if(this.multiple && !Array.isArray(this.value)) {
        this.onValueChange([this.value]);
      } else {
        this.onValueChange(this.value);
      }
      this.updateDisplayList()
    }));
  }

  @Watch('value')
  onValueChange(newVal: any) {
    // console.log(newVal);
    this.localValue = newVal;

    if (this.localValue) {
      if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        if (selectdItems.length > 0) {
          this.selectdItemLabel = selectdItems.map(item => item.label).join(', ');
        } else {
          this.selectdItemLabel = ''
        }

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        if (selectdItem) {
          this.selectdItemLabel = selectdItem.label;
        } else {
          this.selectdItemLabel = ''
        }
      }
    } else {
      this.selectdItemLabel = ''
    }
  }

  @Watch('relFilter')
  onRelFilterChange(newVal: any) {
    console.log('onRelFilterChange');
    this.updateValue(null);
    this.loadData();
  }

  updateValue(value: any) {
    this.onValueChange(value);
    this.$emit('input', value);

    if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        this.$emit('input-object', selectdItems);

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        this.$emit('input-object', selectdItem);
      }
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    console.log('this.dropdownActive', this.dropdownActive, this.$refs.searchInput);
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus()
    }
  }

  @Watch('searchText')
  updateDisplayList() {
    this.$set(this, 'itemsForDisplay', (this.items || []).filter((item: any) => {
      return item.label.toLowerCase().includes(this.searchText);
    }))
  }

  // search($event) {
  //   throttle
  // }
}
